import { useEffect } from 'react';
import { getDecrypted, getFromLocalStorage } from '@/utils/functions/helperFunctions';
import { server_address } from '@/constants/allconstants';
import { io } from 'socket.io-client';

const socket = io(server_address);

export const useNotificationTrigger = (event: string, fetchStats: () => void, isFetch = false) => {
  const user_id = getFromLocalStorage('userId');

  useEffect(() => {
    socket.on(event, (data: any) => {
      if (data.includes(getDecrypted(user_id))) {
        fetchStats();
      }
    });

    if (isFetch) {
      fetchStats();
    }

    return () => {
      socket.off(event);
    };
  }, [event, user_id]);
};
